import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//

import { unusualSaleStatusMap, saleLabelMap } from '@/common/projectStatus';
export default {
  name: 'sale-label-list',
  props: {
    /**
    (0, "初始态"),
    (1, "取消"),
    (2, "延期"),
    (3, "部分延期"),
    (4, "部分取消"),
    (5, "部分延期,部分取消无可售"),
    (6, "部分延期,部分取消部分可售");
    */
    unusualSaleStatus: {
      type: Number,
      default: 0
    },
    /**
      (1, "即将开售"),
      (2, "预订"),
      (3, "售票中"),
      (4, "已无票"),
      (5, "已结束"),
      (11, "即将开抢");
    */
    saleLabel: {
      type: Number
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    saleLabelObj: function saleLabelObj() {
      var unusualSaleStatus = this.unusualSaleStatus,
        saleLabel = this.saleLabel;
      // 优先展示销售异常状态
      if (unusualSaleStatus && unusualSaleStatusMap[unusualSaleStatus]) {
        return unusualSaleStatusMap[unusualSaleStatus];
      }
      // 销售标签
      return saleLabelMap[saleLabel] || '';
    }
  }
};